export default {
	list: [],
	selection: []
}